module.exports = __webpack_public_path__ + "static/media/ph.6ae85442.svg";